module.exports = __webpack_public_path__ + "img/yourordermobile_en.45e28106.png";